import { render, staticRenderFns } from "./PartnerApprovalAll.vue?vue&type=template&id=04bf0e02&scoped=true"
import script from "./PartnerApprovalAll.vue?vue&type=script&lang=js"
export * from "./PartnerApprovalAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf0e02",
  null
  
)

export default component.exports